import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"
import {
  Form,
  Input,
  Button,
  Card,
  Typography,
  Space,
  Alert,
  Divider,
  Row,
  Col,
} from "antd"
import {
  UserOutlined,
  LockOutlined,
  HomeOutlined,
  SendOutlined,
  MessageOutlined,
  ArrowLeftOutlined,
  SafetyOutlined,
  MobileOutlined,
} from "@ant-design/icons"

// action
import { userForgetPassword } from "../../store/actions"

// import images
import logoSm from "../../assets/images/logo-sm.png"

const { Title, Text, Paragraph } = Typography

const ForgetPasswordPage = props => {
  const {loading} = props
  const [form] = Form.useForm()

  const handleSubmit = values => {
    props.userForgetPassword(values, props.history)
  }

  return (
    <React.Fragment>
      <MetaTags>
        <title>بازیابی پسورد | واحد گاز</title>
      </MetaTags>

      {/* Background */}
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px",
          position: "relative",
        }}
      >
        {/* Home Button */}
        <Link
          to="/"
          style={{
            position: "absolute",
            top: 20,
            right: 20,
            color: "#fff",
            fontSize: 24,
          }}
        >
          <HomeOutlined />
        </Link>

        {/* Decorative Elements */}
        <div
          style={{
            position: "absolute",
            top: "10%",
            left: "10%",
            width: 200,
            height: 200,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.1)",
            filter: "blur(40px)",
          }}
        />
        <div
          style={{
            position: "absolute",
            bottom: "15%",
            right: "15%",
            width: 300,
            height: 300,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.08)",
            filter: "blur(60px)",
          }}
        />

        <Card
          style={{
            width: "100%",
            maxWidth: 420,
            borderRadius: 16,
            boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
            border: "none",
            overflow: "hidden",
          }}
          bodyStyle={{ padding: 0 }}
        >
          {/* Header */}
          <div
            style={{
              background: "linear-gradient(135deg, #1890ff 0%, #096dd9 100%)",
              padding: "32px 24px",
              textAlign: "center",
            }}
          >
            <div
              style={{
                width: 80,
                height: 80,
                borderRadius: "50%",
                background: "rgba(255,255,255,0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 16px",
                backdropFilter: "blur(10px)",
              }}
            >
              <img src={logoSm} height="40" alt="logo" />
            </div>
            <Title level={3} style={{ color: "#fff", margin: 0 }}>
              بازیابی رمز عبور
            </Title>
            <Text style={{ color: "rgba(255,255,255,0.8)", fontSize: 13 }}>
              رمز عبور خود را فراموش کرده‌اید؟
            </Text>
          </div>

          {/* Form Section */}
          <div style={{ padding: "32px 24px" }}>
            {/* Info Card */}
            <Card
              size="small"
              style={{
                background: "linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%)",
                borderColor: "#91d5ff",
                borderRadius: 12,
                marginBottom: 24,
              }}
            >
              <Space align="start">
                <MobileOutlined
                  style={{ fontSize: 24, color: "#1890ff", marginTop: 4 }}
                />
                <div>
                  <Text strong style={{ display: "block", marginBottom: 4 }}>
                    بازیابی از طریق پیامک
                  </Text>
                  <Paragraph
                    style={{ margin: 0, fontSize: 13, color: "#666" }}
                  >
                    جهت بازیابی رمز عبور، نام کاربری خود را به شماره{" "}
                    <Text
                      strong
                      copyable
                      style={{ color: "#1890ff", fontFamily: "tahoma" }}
                    >
                      300072266
                    </Text>{" "}
                    پیامک نمایید.
                  </Paragraph>
                </div>
              </Space>
            </Card>

            {/* Alerts */}
            {props.forgetError && (
              <Alert
                message={props.forgetError}
                type="error"
                showIcon
                style={{ marginBottom: 16, borderRadius: 8 }}
              />
            )}
            {props.forgetSuccessMsg && (
              <Alert
                message={props.forgetSuccessMsg}
                type="success"
                showIcon
                style={{ marginBottom: 16, borderRadius: 8 }}
              />
            )}

            <Form
              form={form}
              layout="vertical"
              onFinish={handleSubmit}
              size="large"
            >
              <Form.Item
                name="userName"
                label={
                  <Space>
                    <UserOutlined />
                    <span>نام کاربری</span>
                  </Space>
                }
                rules={[
                  { required: true, message: "نام کاربری الزامی است" },
                ]}
              >
                <Input
                  prefix={<UserOutlined style={{ color: "#bfbfbf" }} />}
                  placeholder="نام کاربری خود را وارد کنید"
                  style={{ borderRadius: 8, height: 48 }}
                />
              </Form.Item>

              <Form.Item style={{ marginBottom: 16 }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  loading={loading}
                  icon={<SendOutlined />}
                  style={{
                    height: 48,
                    borderRadius: 8,
                    fontSize: 15,
                    fontWeight: 500,
                    background: "linear-gradient(135deg, #1890ff 0%, #096dd9 100%)",
                    border: "none",
                  }}
                >
                  درخواست بازیابی
                </Button>
              </Form.Item>
            </Form>

            <Divider style={{ margin: "24px 0" }}>
              <Text type="secondary" style={{ fontSize: 12 }}>
                یا
              </Text>
            </Divider>

            {/* Back to Login */}
            <div style={{ textAlign: "center" }}>
              <Link to="/login">
                <Button
                  type="default"
                  icon={<ArrowLeftOutlined />}
                  style={{
                    borderRadius: 8,
                    height: 44,
                  }}
                >
                  بازگشت به صفحه ورود
                </Button>
              </Link>
            </div>
          </div>

          {/* Footer */}
          <div
            style={{
              background: "#fafafa",
              padding: "16px 24px",
              textAlign: "center",
              borderTop: "1px solid #f0f0f0",
            }}
          >
            <Link to="/login" style={{ color: "#1890ff", fontSize: 13 }}>
              ورود به سیستم
            </Link>
            <Paragraph
              type="secondary"
              style={{ margin: "12px 0 0", fontSize: 11 }}
            >
              <SafetyOutlined style={{ marginLeft: 4 }} />
              Copyright © {new Date().getFullYear()}. واحد گاز کردستان
            </Paragraph>
          </div>
        </Card>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  const { forgetError, forgetSuccessMsg, loading } = state.ForgetPassword
  return { forgetError, forgetSuccessMsg, loading }
}

export default withRouter(
  connect(mapStateToProps, { userForgetPassword })(ForgetPasswordPage)
)
